import axios from "axios"
export function reopenDocumentUpload(userId, token) {
    return axios.get(process.env.REACT_APP_API_URL + `/reopenDocumentUpload?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}